export default __webpack_public_path__ + "static/media/num3.3831549e.png";